import * as React from "react";
const SvgHorseDropped = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	id: "Casino-Lucky-Horseshoe--Streamline-Streamline-3.0",
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Casino Lucky Horseshoe Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M12.545 23.2h-1.088a10.652 10.652 0 0 1 -9.25 -15.944l1.582 -2.77V2.294A1.493 1.493 0 0 1 5.28 0.8h2.987A1.493 1.493 0 0 1 9.76 2.293V5.28a2.975 2.975 0 0 1 -0.398 1.481l-1.97 3.459a4.68 4.68 0 0 0 4.065 7.008h1.088a4.68 4.68 0 0 0 4.065 -7.008l-1.975 -3.46a2.976 2.976 0 0 1 -0.398 -1.481V2.293A1.494 1.494 0 0 1 15.73 0.8h2.987a1.493 1.493 0 0 1 1.494 1.493v2.19l1.581 2.77A10.652 10.652 0 0 1 12.545 23.2v0Z",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M20.215 4.533h-2.24",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M6.028 4.533h-2.24",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M3.788 11.636a0.373 0.373 0 1 1 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M3.788 11.636a0.373 0.373 0 1 0 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M20.18 11.636a0.373 0.373 0 1 1 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M20.18 11.636a0.373 0.373 0 1 0 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M5.939 17.915a0.373 0.373 0 1 1 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M5.939 17.915a0.373 0.373 0 1 0 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M18.064 17.915a0.373 0.373 0 1 1 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M18.064 17.915a0.373 0.373 0 1 0 0 -0.747",
	strokeWidth: 1.5
})), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M12 20.587a0.373 0.373 0 0 1 0 -0.747",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M12 20.587a0.373 0.373 0 0 0 0 -0.747",
	strokeWidth: 1.5
})));
export { SvgHorseDropped as ReactComponent };
